import { CanActivateFn, CanMatchFn, Router, UrlTree } from "@angular/router";
import { inject, PLATFORM_ID } from "@angular/core";
import { isPlatformBrowser } from "@angular/common";
import { LocalStorageService } from "@services/local-storage.service";

export const authGuard: CanMatchFn = (): boolean | UrlTree => {
  const isBrowser = isPlatformBrowser(inject(PLATFORM_ID));
  const router = inject(Router);
  if (!isBrowser) return false;
  const storage = inject(LocalStorageService);
  const token = storage.get<string>("access_token");
  return !!token || router.parseUrl("/login");
};

export const authGuardActivate: CanActivateFn = () => {
  const isBrowser = isPlatformBrowser(inject(PLATFORM_ID));
  const router = inject(Router);
  if (!isBrowser) return false;
  const storage = inject(LocalStorageService);
  const token = storage.get<string>("access_token");
  return !!token || router.parseUrl("/login");
};
